module.exports = __webpack_public_path__ + "static/media/fruits_15.eef20e0e.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_15.csv
// module id = 679
// module chunks = 0